import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {JwtHelperService} from "@auth0/angular-jwt";
import {AuthenticationService} from "@shared/authentication.service";
import {catchError, of, tap} from "rxjs";

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth_service = inject(AuthenticationService);
  const JWT_service = new JwtHelperService();
  // console.log('authGuard', route, state);
  let token = localStorage.getItem("COMIN_currentUser");

  if (!token) {
    // NO TOKEN
    return router.createUrlTree(['/login'], {queryParams: {returnUrl: state.url}});
  } else {

    const T = JSON.parse(token);
    // CHECK TOKEN EXPIRATION
    const T_expired = JWT_service.isTokenExpired(T['access'], 3600);
    // const T_expDate = JWT_service.getTokenExpirationDate(T['access']);
    // console.log(T_expired, T_expDate);

    const allowOrRedirect = function () {
      if(route.data['is_staff'] && !T['is_staff']) {
        // PAGE IS FOR STAFF BUT USER IS CUSTOMER
        return router.createUrlTree(['/user']);

      } else if(!route.data['is_staff'] && T['is_staff']) {
        // PAGE IS FOR CUSTOMER BUT USER IS STAFF
        return router.createUrlTree(['/home']);
      } else {
        return of(true);
      }
    }

    if(T_expired) {
        // console.log('token expired, trying refresh');
        return auth_service.refreshToken(T, state.url);
    } else {
      return allowOrRedirect();
    }


/*    const refresh = auth_service.refreshToken();
    if(refresh) {
      refresh.subscribe({
        next: (res) => {
          return allowOrRedirect();
        },
        error: (err) => {
          return false;
        }
      })
    }*/


  }
};
